var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.703,
    height: 17.703,
    viewBox: "0 0 17.703 17.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mi_delete",
    d: "M6.426,3.77A1.77,1.77,0,0,1,8.2,2h5.311a1.77,1.77,0,0,1,1.77,1.77v1.77h3.541a.885.885,0,0,1,0,1.77h-.946L17.1,18.059A1.77,1.77,0,0,1,15.338,19.7H6.364A1.77,1.77,0,0,1,4.6,18.059L3.832,7.311H2.885a.885.885,0,1,1,0-1.77H6.426ZM8.2,5.541h5.311V3.77H8.2Zm-2.59,1.77.759,10.622h8.975L16.1,7.311Zm3.475,1.77a.885.885,0,0,1,.885.885v5.311a.885.885,0,0,1-1.77,0V9.966a.885.885,0,0,1,.885-.885Zm3.541,0a.885.885,0,0,1,.885.885v5.311a.885.885,0,0,1-1.77,0V9.966a.885.885,0,0,1,.885-.885Z",
    transform: "translate(-2 -2)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.b943503eb19c1dba537d2dd9111fe42e.svg";
export { ForwardRef as ReactComponent };